enum ImportHistryFilterFieldNames {
  StartedAt = 'startedAt',
  Type = 'type',
  Reset = 'reset',
}

export default ImportHistryFilterFieldNames;
